<div>
  <rask-list #searchresult
    class="footer-padding"
    [rowSelectable]="true"
    [data]="searchResult"
    id="produktinstruktionSokResultat"
    [virtualScroll]="true"
    virtualScrollType="window"
    [useClientFilter]="true"
    clientFilterResultText="Produktinstruktioner"
    [virtualScrollItemHeight]="36"
    (checkedChanged)="onCheckedChange()"
    [fixedHeader]="true">
    <rask-list-column-checkbox></rask-list-column-checkbox>
    <rask-list-column width="300px" header="Namn" field="namn" [sortable]="true">
      <ng-template let-row="row">
        <a
          [routerLink]="['/produktinstruktioner', row.puid]">
          {{row.namn}}
        </a>
        <a
          [routerLink]="['/produktinstruktioner', row.puid]"
          target="_blank">
          <i class="far fa-sm fa-external-link p-r-half"></i>
        </a>
      </ng-template>
    </rask-list-column>
    <rask-list-column width="100px" header="Trädslag" field="tradslag" [sortable]="true"
    [tooltip]="true"></rask-list-column>
    <rask-list-column width="135px" header="PUID" field="puid" [sortable]="true"
    [tooltip]="true"></rask-list-column>
    <rask-list-column width="85px" header="Version" field="version" [sortable]="true"
    [tooltip]="true"></rask-list-column>
    <rask-list-column width="100px" header="Sortiment" field="sortiment" [sortable]="true"
    [tooltip]="true"></rask-list-column>
    <rask-list-column width="100px" header="Mottpl" field="mottagningsplats" [sortable]="true"
    [tooltip]="true"></rask-list-column>
    <rask-list-column width="200px" header="Geografi" field="regioner" [sortable]="true"
    [tooltip]="true"></rask-list-column>
    <rask-list-column width="100px" header="HS" field="handelssortiment" [sortable]="true"
    [tooltip]="true"></rask-list-column>
    <rask-list-column width="100px" header="Produkt" field="produkt" [sortable]="true"
    [tooltip]="true"></rask-list-column>
    <rask-list-column width="85px" header="Kapfönster" field="kapfonster" [sortable]="true"
    [tooltip]="true"></rask-list-column>
    <rask-list-column width="100px" header="Min/Max topp dia" field="minMaxTopDiameter" [sortable]="true"
    [tooltip]="true"></rask-list-column>
    <rask-list-column width="100px" header="Skapad datum" field="skapad" [sortable]="true" [nowrap]="true"
    [tooltip]="true"></rask-list-column>
    <rask-list-column width="140px" header="Senast ändrad" field="senastAndrad" [sortable]="true" [nowrap]="true"
    [tooltip]="true"></rask-list-column>
    <rask-list-column width="50px" header="Aktiv" field="aktiv">
      <ng-template let-value>
        @if (value) {
          <i class="far fa-check"></i>
        }
      </ng-template>
    </rask-list-column>
  </rask-list>
</div>